import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "input", "results", "selection"]

  disconnect() {
    if (this.searchTimeout) clearTimeout(this.searchTimeout)
  }

  filter() {
    if (this.searchTimeout) clearTimeout(this.searchTimeout)

    const searching = this.inputTarget.value.trim().length >= 3
    this.resultsTarget.hidden = !searching
    this.selectionTarget.hidden = searching

    if (searching) {
      this.searchTimeout = setTimeout(() => this.formTarget.requestSubmit(), 250)
    }
  }
}
